import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SidebarMenuItem } from '@/components/ui-kit/sidebar';
import { SidebarMenuItemProps } from '@/types/sidebar.type';
import { MenuIcon, SIDEBAR_NAV_ICON_SIZE } from '@/components/core';
import { matchesSidebarPath } from '@/lib/utils/sidebar-utils';
import { navIconClass, navItemClass, navLabelClass } from '../app-sidebar/nav-styles';

/**
 * A top-level sidebar page without a group (People, Service Requests): icon and label, styled as the
 * HR Module Prototype's Component Map says (see `nav-styles.ts`). `isRail` lays it out for the
 * collapsed 5rem rail, with the label under the icon.
 */
export const SidebarMenuItemComponent = ({
  item,
  isRail = false,
  isActive: isActiveProp,
  onClick,
}: Readonly<SidebarMenuItemProps>) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isActive = isActiveProp ?? matchesSidebarPath(pathname, item.path);

  return (
    <SidebarMenuItem>
      <Link
        to={item.path}
        className={navItemClass({ active: isActive, rail: isRail })}
        onClick={onClick}
        aria-current={isActive ? 'page' : undefined}
      >
        {item.icon && (
          <MenuIcon
            name={item.icon}
            size={SIDEBAR_NAV_ICON_SIZE}
            className={navIconClass({ active: isActive, rail: isRail })}
          />
        )}
        <span className={navLabelClass({ active: isActive, rail: isRail })}>{t(item.name)}</span>
      </Link>
    </SidebarMenuItem>
  );
};
